export const BaseUrl = "https://api.catalyze.co.in/";
// export const BaseUrl = "http://localhost:8010/";


export const accessToken = localStorage.getItem("catalyzeToken");
